export default "/images/logo.svg?da0d7a3be806be3fa8e4fe878a0f4155";